import axios from "axios"
import authAxios from "./axios-instance/authAxios";

const mainApiHost = process.env.REACT_APP_MAIN_API_HOST;

export function UserPagesApi(props) {
    return {
        searchByAuthUser: async ({ headers, params, body }) => {
            return await authAxios.get(`${mainApiHost}/user-pages/search/authUser`, {
                headers: headers,
                withCredentials: true
            })
        },
        create: async ({ headers, params, body, }) => {
            return await authAxios.post(`${mainApiHost}/user-pages/create`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        update: async ({ body, headers }) => {
            return await authAxios.put(`${mainApiHost}/user-pages/update`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_noticeConfig: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/noticeConfig`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_searchConfig: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/searchConfig`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_socialConfig: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/socialConfig`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_viewCategoryFlag: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/viewCategoryFlag`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_backgroundDesign: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/backgroundDesign`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_pageFont: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/pageFont`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_designs: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/user-pages/one/designs`, body, {
                headers: headers,
                withCredentials: true
            })
        },


        searchOne: async ({ params, headers }) => {
            return await axios.get(`${mainApiHost}/user-pages/${params?.id}`, {
                headers: headers
            });
        },
        searchByDomainName: async ({ params, headers }) => {
            return await axios.get(`${mainApiHost}/user-pages/domainName/${params?.domainName}`, {
                headers: headers
            });
        },
        isExistedSameDomain: async ({ body, headers }) => {
            return await axios.post(`${mainApiHost}/user-pages/isExistedSameDomain`, body, {
                headers: headers,
            })
        },
    }
}